module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13 21.167h6v-6h4l-7-7-7 7h4v6zm-4 2h14v2H9v-2z\"></path></svg>"